module.exports = __webpack_public_path__ + "static/img/banner01.c4c36610.jpg";